import { render } from "./LockScreen.vue?vue&type=template&id=b3c266b6&scoped=true"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"

import "./LockScreen.vue?vue&type=style&index=0&id=b3c266b6&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c266b6"]])

export default __exports__